import { extend, $ } from './HelperFunctions'

export class Header {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      Burger: '.header__burger',
      SearchButton: '.header__search > .button--search',
      SearchInput: '.header__search .form__input',
      SelectLanguageButton: '.header .button--select-language'
    }, selectors)

    this.classes = extend({
      Active: 'header--active',
      HeaderSearch: 'header__search',
      SelectLanguage: 'select-language'
    }, classes)
  }

  init () {
    this.$burger = $(this.selectors.Burger)
    this.$searchButton = $(this.selectors.SearchButton)
    this.$selectLanguageButton = $(this.selectors.SelectLanguageButton)

    this.events()
  }

  events () {
    if (this.$burger) {
      this.$burger.addEventListener('click', () => {
        if (this.$burger.classList.contains(this.classes.Active)) {
          this.$burger.classList.remove(this.classes.Active)
        } else {
          this.$burger.classList.add(this.classes.Active)
        }
      })
    }

    if (this.$searchButton) {
      this.$searchButton.addEventListener('click', () => {
        if (this.$searchButton.classList.contains(this.classes.Active)) {
          this.$searchButton.classList.remove(this.classes.Active)
        } else {
          this.$searchButton.classList.add(this.classes.Active)
          $(this.selectors.SearchInput).focus()
        }
      })
    }

    if (this.$selectLanguageButton) {
      this.$selectLanguageButton.addEventListener('click', () => {
        if (this.$selectLanguageButton.classList.contains(this.classes.Active)) {
          this.$selectLanguageButton.classList.remove(this.classes.Active)
        } else {
          this.$selectLanguageButton.classList.add(this.classes.Active)
        }
      })
    }

    $('body').addEventListener('click', (event) => {
      if (!this.hasParentsClass(event.target, this.classes.HeaderSearch) && this.$searchButton) {
        this.$searchButton.classList.remove(this.classes.Active)
      }

      if (!this.hasParentsClass(event.target, this.classes.SelectLanguage) && this.$selectLanguageButton) {
        this.$selectLanguageButton.classList.remove(this.classes.Active)
      }
    })

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        if (this.$burger) {
          this.$burger.classList.remove(this.classes.Active)
        }

        if (this.$searchButton) {
          this.$searchButton.classList.remove(this.classes.Active)
        }

        if (this.$selectLanguageButton) {
          this.$selectLanguageButton.classList.remove(this.classes.Active)
        }
      }
    })
  }

  hasParentsClass (element, classname) {
    if (element.classList.contains(classname)) {
      return true
    }

    return element.parentElement && this.hasParentsClass(element.parentElement, classname)
  }
}

export default Header
